module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/larger-than-sign-d95c3ac6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/larger-than-sign.svg
// module id = ./app/web/src/assets/larger-than-sign.svg
// module chunks = 0